import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { useGetDateQuery } from '../../../../../../redux/services/fo_dates.jsx';
import { Spinner } from '../../../../../common/index.jsx';
import DatesDetail from '../../../../../common/FriOpen/Dates/DatesDetails.jsx';

const FoDatesDetailPage = () => {
  const { t } = useTranslation();
  const { dateId } = useParams();

  const { data: date, isLoading: isLoadingDate } = useGetDateQuery(dateId);

  return (
    <>
      <AppBarCMS
        title={t('FRI akcia - detail termínu')}
        backUrl={-1}
        backUrlTooltip={t('Späť')}
        permissionsBasic={'fo-dates'}
      />

      {isLoadingDate ? <Spinner /> : <DatesDetail date={date} />}
    </>
  );
};

export default FoDatesDetailPage;
